import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
export default function (source, keys) {
  return Array.from(keys, function (key) {
    return source[key];
  });
}